'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _highcharts = require('../library/highcharts');

var _fwwRepository = require('../library/fww-repository');

var _validation = require('../library/validation');

var _defaultsDeep = require('lodash/defaultsDeep');

var _defaultsDeep2 = _interopRequireDefault(_defaultsDeep);

var _tinytim = require('../library/tinytim');

var _tinytim2 = _interopRequireDefault(_tinytim);

var _log = require('../library/log');

var log = _interopRequireWildcard(_log);

var _environment = require('../library/environment');

var _parse = require('date-fns/parse');

var _parse2 = _interopRequireDefault(_parse);

var _timeSeries = require('../configurations/highcharts/time-series.json');

var _timeSeries2 = _interopRequireDefault(_timeSeries);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    name: 'time-series',

    template: require('./time-series.component.html'),

    props: {
        funds: {
            validator: (0, _validation.jsonSchemaPropValidator)(require('../schema/funds-for-time-series.schema.json')),
            required: true
        },
        peergroups: {
            type: Array,
            required: false,
            default: function _default() {
                return [];
            }
        }
    },

    data: function data() {
        return {
            chart: null
        };
    },


    /**
     * Asynchronously initialize the chart on mount.
     */
    mounted: function mounted() {
        var _this = this;

        log.info('time-series', 'mounted', this.$el);

        // Wait until both, highcharts and timeseries data is available
        // (both will be loaded at the same time)
        setTimeout(function () {
            _promise2.default.all([(0, _highcharts.initializeHighstocks)(), _this.refetchTimeSeries()]).then(function (_ref) {
                var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    Highcharts = _ref2[0],
                    timeseries = _ref2[1];

                log.debug('time-series', 'Highcharts & timeseries loaded');
                _this.chart = _this.initializeGraph(Highcharts, timeseries);
            }, function (e) {
                return log.error('time-series', e);
            });
        });
    },


    /**
     * Destroy the chart, when the component is destroyed.
     * This helps save memory and also prevents a bug where Vue re-uses component instances and
     * flashes an old chart before painting the new one.
     */
    beforeDestroy: function beforeDestroy() {
        log.debug('time-series', 'beforeDestroy');
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
        if (this.$refs.chart) {
            this.$refs.chart.innerHTML = '';
        }
    },


    methods: {

        /**
         * Initializes the graph that is being displayed.
         *
         * This method expects the Highcharts object to be passed as the first argument and
         * the result of the timeseries call as the second one.
         *
         * This method should only be called once during the lifetime of the component.
         *
         * @param Highcharts
         * @param timeseries
         */
        initializeGraph: function initializeGraph(Highcharts, timeseries) {
            log.info('time-series', 'initializeGraph', Highcharts, timeseries);
            var chart = void 0;

            var defaults = {
                tooltip: {
                    formatter: function formatter() {
                        return (0, _tinytim2.default)(_timeSeries2.default.tooltip._format, {
                            name: this.series.name,
                            change: Highcharts.numberFormat(this.point.y)
                        });
                    }
                },

                xAxis: {
                    events: {
                        afterSetExtremes: function afterSetExtremes(event) {
                            scaleSeriesDataToCompare(this.chart, event.min);
                        }
                    },
                    max: +new Date()
                }
            };

            var options = (0, _defaultsDeep2.default)(_timeSeries2.default, defaults);
            if ((0, _environment.isPdf)()) {
                options = (0, _defaultsDeep2.default)({
                    navigator: { enabled: false },
                    rangeSelector: { enabled: false },
                    chart: { events: { load: null } },
                    tooltip: { formatter: null }
                }, options);
            }

            // Initialize chart
            log.debug('time-series', 'initializing graph', options);
            chart = Highcharts.chart(this.$refs.chart, options);
            log.debug('time-series', 'graph initialized', chart);
            this.updateGraph(timeseries, chart);
            return chart;
        },


        /**
         * Updates the graph with the new timeseries data.
         */
        updateGraph: function updateGraph(timeseries) {
            var _this2 = this;

            var chart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.chart;

            log.info('time-series', 'updateGraph', timeseries, chart);
            if (!chart) {
                return log.debug('time-series', 'updateGraph', 'chart is non-existent, aborting');
            }

            (0, _validation.validate)(timeseries, require('../schema/time-series.schema.json'));

            // Prepare data.
            var i = 0;
            var series = (0, _keys2.default)(timeseries).map(function (key) {
                var data = timeseries[key];

                log.debug('time-series', 'updateGraph', 'preparing series ' + i);
                var fond = _this2.fondByIsin(data.meta.id);
                log.debug('time-series', 'updateGraph', 'preparing series ' + i, 'found fond', fond);

                var series = {
                    name: data.meta.name,
                    fond: fond,
                    currency: data.meta.currency,
                    isin: data.meta.id,
                    zIndex: 2,

                    // The data is converted for usage in a timeseries:
                    // The dates are converted to timestamps and the values are multiplied
                    // with the correct price.
                    data: data.ts.map(function (arr) {
                        return [(0, _parse2.default)(arr[0]).getTime(), arr[1]];
                    })
                };

                log.debug('time-series', 'updateGraph', 'timeParsing example', 'this should output a date string first and a timestamp second', data.ts[0][0], (0, _parse2.default)(data.ts[0][0]).getTime());

                // Override series settings for peergroups
                if (data.meta.id.indexOf('-3') > -1) {
                    log.debug('time-series', 'updateGraph', 'preparing series ' + i, 'is peergroup');
                    (0, _keys2.default)(chart.options._peergroupSeriesOverride).forEach(function (key) {
                        return series[key] = chart.options._peergroupSeriesOverride[key];
                    });
                }

                log.debug('time-series', 'updateGraph', 'prepared series ' + i, series);
                ++i;
                return series;
            });

            // Remove old series (without redrawing for every series)
            while (chart.series.length > 0) {
                log.debug('time-series', 'updateGraph', 'removing series', chart.series[0]);
                chart.series[0].remove(false);
            }

            // Add new series (without redrawing for every series)
            series.forEach(function (s) {
                log.debug('time-series', 'updateGraph', 'adding series', s);
                chart.addSeries(s, false);
            });

            // Redraw with animation (but not for PDFs)
            log.debug('time-series', 'updateGraph', 'redrawing chart');
            chart.redraw(!(0, _environment.isPdf)());
            scaleSeriesDataToCompare(chart, chart.axes[0].min);
        },


        /**
         * Returns the fond with the given isin.
         */
        fondByIsin: function fondByIsin(isin) {
            log.debug('time-series', 'fondByIsin', isin);
            return this.funds.filter(function (f) {
                return f.isin === isin;
            })[0];
        },


        /**
         * Refetches time series an returns a unified promise for that.
         */
        refetchTimeSeries: function refetchTimeSeries() {
            var isins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.isins;
            var peergroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.peergroups;

            log.info('time-series', 'refetchTimeSeries', isins, peergroups);

            var timeSeriesToRequest = [];

            // All isins have to be requested.
            isins.forEach(function (isin) {
                return timeSeriesToRequest.push(isin);
            });

            // Peergroups have to be requested in a composite format including the next digit.
            // Peergroups need to have the 'magical' suffix `-3` in order to get the correct data from the API.
            peergroups.filter(function (peergroup) {
                return !!peergroup;
            }).map(function (peergroup) {
                return ('' + peergroup).indexOf('-3') === -1 ? peergroup + '-3' : peergroup;
            }).forEach(function (peergroup) {
                return timeSeriesToRequest.push(peergroup);
            });

            log.debug('time-series', 'refetchTimeSeries', timeSeriesToRequest);
            return (0, _fwwRepository.getTimeSeries)(timeSeriesToRequest).then(function (ts) {
                log.debug('time-series', 'refetchTimeSeries', 'success', ts);
                return ts;
            }, function (e) {
                log.error('time-series', 'refetchTimeSeries', e);
            });
        }
    },

    computed: {

        /**
         * Returns the isins of all current funds.
         */
        isins: function isins() {
            return this.funds.map(function (f) {
                return f.isin;
            });
        }
    },

    watch: {

        /**
         * Update the graph if new ISINs are given.
         */
        isins: {
            handler: function handler(isins) {
                var _this3 = this;

                log.info('time-series', 'watcher: isins', isins);

                // Do nothing, if the chart has not been initialized yet.
                if (!this.chart) {
                    log.debug('time-series', 'watcher: isins', 'chart not initialized yet, aborting');
                    return;
                }

                this.refetchTimeSeries(isins).then(function (timeseries) {
                    return _this3.updateGraph(timeseries);
                }, function (e) {
                    return log.error(e);
                });
            },

            deep: true
        },

        peergroups: {
            handler: function handler(peergroups) {
                var _this4 = this;

                log.info('time-series', 'watcher: peergroups', peergroups);

                // Do nothing, if the chart has not been initialized yet.
                if (!this.chart) {
                    log.debug('time-series', 'watcher: peergroups', 'chart not initialized yet, aborting');
                    return;
                }

                this.refetchTimeSeries(this.isins, peergroups).then(function (timeseries) {
                    return _this4.updateGraph(timeseries);
                }, function (e) {
                    return log.error(e);
                });
            }
        }

    }
};

/**
 * Scales the series data of the given chart in order to be comparable.
 * The Value of each series at the given point in time will be set as 100%
 * and only changes to the course will be displayed in the chart.
 *
 * If a series does not have a record at the given point in time then the value
 * will be linearly interpolated from the two points before and after it.
 *
 * If a series does not exist at the given point in time (start only after
 * the chosen window) then the series will be normalized to its first record.
 *
 * @param chart
 * @param compareFrom
 */

function scaleSeriesDataToCompare(chart, compareFrom) {
    var _loop = function _loop(series) {
        var currentValue = getSeriesValueAtTime(series, compareFrom) || series.yData[0];

        // This currentValue is the new baseline: It is now set to be 100%.
        var multiplier = 100 / currentValue;
        var data = series.options.data;
        data.forEach(function (point) {
            return point[1] *= multiplier;
        });
        series.setData(data);
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(chart.series), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var series = _step.value;

            _loop(series);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    chart.redraw(!(0, _environment.isPdf)());
}

/**
 * Gets the value of the graph at the given point in time.
 * If there is no exact record at the given time but one before and one after it
 * then the value will be interpolated from it's neighbors.
 *
 * If there truly is no record at that time then `null` will be returned
 * instead.
 *
 * @param series
 * @param time
 * @returns {*}
 */
function getSeriesValueAtTime(series, time) {
    if (series.options.data.length === 0) {
        return null;
    }

    // Find the current value for the series.
    for (var i = 0; i < series.options.data.length - 1; i++) {
        var point = series.options.data[i];
        var next = series.options.data[i + 1];

        if (!point) {
            continue;
        }

        if (time >= point[0] && time <= next[0]) {
            var range = next[0] - point[0];
            var weight = (next[0] - time) / range;
            return weight * point[1] + (1 - weight) * next[1];
        }
    }

    return null;
}